import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  formValueSelector,
  initialize,
  getFormValues,
} from "redux-form";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { fetchTemplate } from "SettingActions";
import { showError, showSuccess } from "ReduxErrorBar";
import { validateSMTP, addTemplate, updateTemplate } from "SettingActions";
import { COMMON_FAIL_MESSAGE, validateEmail } from "Constants";
import LocaleStrings from "Languages";

class SMTP extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
    this.state = { testbtnloading: false };
  }

  componentDidMount() {
    // this.props.fetchTemplate(this.props.session);
  }

  onSubmitForm = (data) => {
    // console.log("data :- ", data);
    let values = { smtp: data.smtp };

    if (data.smtp === "own") {
      values.host = data.host.trim();
      values.port = data.port.trim();
      values.user = data.user.trim();
      values.password = data.password.trim();
      values.fromemail = data.fromemail.trim();
      values.test_email_smtp = false;
    } else {
      values.host = "";
      values.port = "";
      values.user = "";
      values.password = "";
      values.fromemail = "";
    }

    // console.log("values final :- ", values);

    this.setState({ loading: true });
    if (values.smtp == "eventify") {
      if (!this.props.editMode) {
        this.props.addTemplate(this.props.session, values, (response) => {
          if (response.success === 0) {
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            this.props.showSuccess(LocaleStrings.template_smtp_setting_success);
          }
          this.setState({ loading: false });
          this.closeSMTPModal();
        });
      } else {
        values.id = data.id;
        this.props.updateTemplate(this.props.session, values, (response) => {
          if (response.success === 0) {
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            this.props.showSuccess(LocaleStrings.template_smtp_setting_success);
          }
          this.setState({ loading: false });
        });
      }
    } else {
      this.props.validateSMTP(this.props.session, values, (validate) => {
        if (validate.success === 1) {
          if (!this.props.editMode) {
            this.props.addTemplate(this.props.session, values, (response) => {
              if (response.success === 0) {
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.showSuccess(
                  LocaleStrings.template_smtp_setting_success
                );
              }
              this.setState({ loading: false });
              this.closeSMTPModal();
            });
          } else {
            values.id = data.id;
            this.props.updateTemplate(
              this.props.session,
              values,
              (response) => {
                if (response.success === 0) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.props.showSuccess(
                    LocaleStrings.template_smtp_setting_success
                  );
                }
                this.setState({ loading: false });
                this.closeSMTPModal();
              }
            );
          }
        } else {
          this.setState({ loading: false });
          this.props.showError(
            LocaleStrings.template_smtp_setting_credential_error
          );
        }
      });
    }
  };

  closeSMTPModal = () => {
    this.props.closeSMTPModal();
  };

  sendTestemail = () => {
    let { formValues } = this.props;

    let data = formValues;
    let values = { smtp: "own" };
    values.host = data.host.trim();
    values.port = data.port.trim();
    values.user = data.user.trim();
    values.password = data.password.trim();
    values.fromemail = data.fromemail.trim();
    values.receiver_email = data.receiver_email.trim();
    values.test_email_smtp = true;

    if (
      values.host == "" ||
      values.port == "" ||
      values.user == "" ||
      values.password == "" ||
      values.fromemail == "" ||
      values.receiver_email == ""
    ) {
      this.props.showError(
        LocaleStrings.setting_email_template_testemail_validate
      );
    } else {
      this.setState({ testbtnloading: true });
      this.props.validateSMTP(this.props.session, values, (validate) => {
        if (validate.success === 1) {
          this.props.showSuccess(
            LocaleStrings.setting_email_template_testemail_success
          );
          this.setState({ testbtnloading: false });
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
          this.setState({ testbtnloading: false });
        }
      });
    }
  };

  render() {
    var {
      handleSubmit,
      pristine,
      invalid,
      submitting,
      editMode,
      smtpModal,
      smtpType,
    } = this.props;
    // console.log("smtpType :- ", smtpType);

    return (
      <Modal
        show={smtpModal.show === true ? true : false}
        onHide={this.closeSMTPModal}
        dialogClassName="modal-md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        enforceFocus={false}
        animation={true}>
        <form
          onSubmit={handleSubmit(this.onSubmitForm)}
          encType="multipart/form-data">
          <Modal.Header>
            <Modal.Title>
              <div className="title-modal">
                {LocaleStrings.template_setting_form_label_smtp_type}
              </div>
            </Modal.Title>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={this.closeSMTPModal}>
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body className="scrollable-modal">
            <div className="row h-full">
              <div className="col-sm-8">
                <SMTPSetting
                  editMode={editMode}
                  initialValues={this.props.initialValues}
                  {...this.props}
                />
              </div>
              <div className="col-sm-4 bg-white-">
                <div className="email-template-info-container mt-3">
                  <div className="content-title">
                    <img
                      style={{ width: 14, height: 14 }}
                      src="../../style/images/cheklisticons/info-theme.svg"
                      alt="templateinfo"
                    />
                    <span className="custom-text1-theme-medium">
                      {LocaleStrings.notes}
                    </span>
                  </div>
                  {smtpType === "eventify" ? (
                    <ul className="content-body">
                      <li className="custom-text1-primary-normal">
                        {
                          LocaleStrings.template_setting_form_label_smtp_setting_note1
                        }
                      </li>
                    </ul>
                  ) : smtpType === "own" ? (
                    <ul className="content-body">
                      <li className="custom-text1-primary-normal">
                        {
                          LocaleStrings.template_setting_form_label_smtp_setting_note2
                        }
                      </li>
                      <li className="custom-text1-primary-normal">
                        {
                          LocaleStrings.template_setting_form_label_smtp_setting_note3
                        }
                      </li>
                      <li className="custom-text1-primary-normal">
                        {
                          LocaleStrings.template_setting_form_label_smtp_setting_note4
                        }
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              className="btn btn-custom-white"
              onClick={this.closeSMTPModal}>
              {LocaleStrings.button_close}
            </Button>

            <Button
              type="submit"
              className="btn-custom-blue"
              disabled={pristine || invalid || submitting}
              loading={this.state.loading}>
              {smtpType === "own"
                ? LocaleStrings.button_connection_save
                : LocaleStrings.button_save}
            </Button>

            {smtpType === "own" ? (
              <Button
                type="button"
                className="btn-custom-blue"
                loading={this.state.testbtnloading}
                // disabled={pristine || invalid || submitting}
                onClick={this.sendTestemail}>
                {LocaleStrings.setting_email_template_btn_testemail}
              </Button>
            ) : (
              ""
            )}
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

function validate(values) {
  var errors = {};

  var smtp = values["smtp"];
  var host = values["host"];
  var port = values["port"];
  var user = values["user"];
  var password = values["password"];
  var fromemail = values["fromemail"];

  if (smtp === "") {
    errors["smtp"] = LocaleStrings.required;
  }

  if (smtp && smtp === "own") {
    if (!host || host.trim === "") errors["host"] = LocaleStrings.required;
    if (!port || port.trim === "") errors["port"] = LocaleStrings.required;
    if (!user || user.trim === "") errors["user"] = LocaleStrings.required;
    if (!password || password.trim === "")
      errors["password"] = LocaleStrings.required;

    if (!fromemail || fromemail.trim === "") {
      errors["fromemail"] = LocaleStrings.required;
    } else if (fromemail && !validateEmail(fromemail)) {
      errors["fromemail"] = LocaleStrings.invalid_email;
    }
  }

  return errors;
}

const selector = formValueSelector("SMTPForm");

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;
  if (
    state.templateData &&
    state.templateData.resource &&
    state.templateData.resource.length > 0
  ) {
    initVals = state.templateData.resource[0];
    toEdit = true;
  }
  initVals.receiver_email = state.user?.email;

  return {
    session: state.session,
    editMode: toEdit,
    initialValues: initVals,
    formValues: getFormValues("SMTPForm")(state),
    // form field values
    smtpType: selector(state, "smtp"),
  };
}

export default connect(mapStateToProps, {
  validateSMTP,
  addTemplate,
  updateTemplate,
  showError,
  showSuccess,
  fetchTemplate,
})(
  reduxForm({
    validate,
    form: "SMTPForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(SMTP)
);

class SMTPSetting extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { eventifySmtp: true };
  }

  componentDidMount() {
    if (
      this.props.initialValues &&
      this.props.initialValues.smtp &&
      this.props.initialValues.smtp === "own"
    ) {
      this.setState({ eventifySmtp: false });
    } else {
      this.setState({ eventifySmtp: true });
    }
  }

  smtpChange = (e) => {
    let change = e.target.value;

    if (change === "own") {
      this.setState({ eventifySmtp: false });
    } else {
      this.setState({ eventifySmtp: true });
    }
  };

  render() {
    var { eventifySmtp } = this.state;

    return (
      <>
        <div className="form-group row">
          <label className="control-label-top col-sm-12">
            {LocaleStrings.template_setting_form_label_smtp_type}
          </label>
          <div className="col-md-12" style={{ fontSize: 13 }}>
            <Field
              name="smtp"
              component="input"
              type="radio"
              value="eventify"
              onChange={this.smtpChange}
            />{" "}
            {LocaleStrings.template_setting_form_label_smtp_type_option1}{" "}
            <Field
              name="smtp"
              component="input"
              style={{ marginLeft: 20 }}
              type="radio"
              value="own"
              onChange={this.smtpChange}
            />{" "}
            {LocaleStrings.template_setting_form_label_smtp_type_option2}
          </div>
        </div>

        {!eventifySmtp ? (
          <>
            <Field
              name="host"
              label={LocaleStrings.template_setting_form_label_host}
              placeholder={LocaleStrings.template_setting_form_ph_host}
              type="text"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
            />
            <Field
              name="port"
              label={LocaleStrings.template_setting_form_label_port}
              placeholder={LocaleStrings.template_setting_form_ph_port}
              type="text"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
            />
            <Field
              name="user"
              label={LocaleStrings.template_setting_form_label_user}
              placeholder={LocaleStrings.template_setting_form_ph_user}
              type="text"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
            />
            <Field
              name="password"
              label={LocaleStrings.template_setting_form_label_password}
              placeholder={LocaleStrings.template_setting_form_ph_password}
              type="password"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
            />
            <Field
              name="fromemail"
              label={LocaleStrings.template_setting_form_label_fromemail}
              placeholder={LocaleStrings.template_setting_form_ph_fromemail}
              type="text"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
            />

            <Field
              name="receiver_email"
              label="Test connection receiver's email"
              placeholder="Test connection receiver's email"
              type="text"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
            />
          </>
        ) : (
          <div style={{ minHeight: 20 }}></div>
        )}
      </>
    );
  }
}
